import React, { Fragment } from 'react';

const About = () => {
  return (
    <Fragment>
      <h1>About this page</h1>
      <p>App to search GitHub Users using React created as POC. </p>
      <p>Version: 1.0.0</p>
      <p>Mahesh.</p>
    </Fragment>
  );
};

export default About;
